
import BASE from '../config';

// export const BASE_URL = "https://pratapabhang.tech/API";
// export const BASE_URL = "http://localhost:4000";


// export const BASE_URL = "https://aptispark.com/API";
export const BASE_URL = BASE;
export const USERS = "/Users.php";
// export const USERS = "/users";
export const DESIGNATION_URL = USERS+"/getUsersDesignations";
export const GET_USERS_URL = USERS+"/getUsers";
export const ADD_UPDATE_USER_URL = USERS+"/addOrUpdateUsers";
export const DELETE_USER_URL = USERS+"/deleteUser";
export const LOGIN_URL = USERS+"/login";

export const IMPACT_NUMBER_URL = "/ImpactNumber.php";
// export const IMPACT_NUMBER_URL = "/impactNumbers";
export const GET_IMPACT_NUMBER_URL = IMPACT_NUMBER_URL+"/getImpactNumberConfig";
export const ADD_UPDATE_IMPACT_NUMBER_URL = IMPACT_NUMBER_URL+"/addOrUpdateImpactNumber";

export const CURRENT_OPENINGS_URL = "/CurrentOpenings.php";
// export const CURRENT_OPENINGS_URL = "/currentOpenings";
export const GET_CURRENT_OPENINGS_URL = CURRENT_OPENINGS_URL+"/getCurrentOpeningConfigs";
export const ADD_UPDATE_CURRENT_OPENINGS = CURRENT_OPENINGS_URL+"/addOrUpdateCurrentOpenings";
export const DELETE_CURRENT_OPENINGS = CURRENT_OPENINGS_URL+"/deleteCurrentOpenings";

export const CANDIDATE_TESTIMONY_URL = "/CandidateTestimony.php";
// export const CANDIDATE_TESTIMONY_URL = "/candidateTestimony";

export const GET_CANDIDATE_TESTIMONY_URL = CANDIDATE_TESTIMONY_URL+"/getCandidateTestimonyConfig";
export const ADD_UPDATE_CANDIDATE_TESTIMONY_URL = CANDIDATE_TESTIMONY_URL+"/addUpdateCandidateTestimony";
export const DELETE_CANDIDATE_TESTIMONY_URL = CANDIDATE_TESTIMONY_URL+"/deleteCandidateTestimony";

export const BANNER_URL = "/Banners.php";
// export const BANNER_URL = "/banner";
export const GET_BANNER_URL = BANNER_URL+"/getBannerConfig";
export const ADD_UPDATE_BANNER_URL = BANNER_URL+"/addUpdateBanner";
export const DELETE_BANNER_URL = BANNER_URL+"/deleteBanner";

export const GET_CONFIG = "/getConfig.php";
// export const GET_CONFIG = "/configs/getConfig";
// export const ADD_JOB_APPLICATION = "/jobApplication";
// export const ADD_JOB_APPLICATION_SUBMIT = "/submit";
export const ADD_JOB_APPLICATION = "/addJobApplication.php";
